// Prompt: The question.Multi
// Multi: Can the user select multiple check boxes? False for Radio module.
// usesSymbol: Override the colour wheel by using true. Replaces it with SymbolBox.
// options: Answers the user can select.

const questions = [
  // self: relates to the chevron on the left side of the flag
  {
    prompt: "Personally, I feel I am...",
    multi: true,
    usesSymbol: false,
    neighbours: false,
    options: {
      red: "Feminine",
      orange: "Somewhat feminine",
      yellow: "Neither feminine nor masculine",
      green: "Somewhat masculine",
      blue: "Masculine",
      purple: "Androgynous",
    },
    // suffix: {
    //   red: "Woman",
    //   grey: "Non-binary person",
    //   blue: "Man",
    // },
  },

  // body
  {
    prompt: "...and I see my body as...",
    multi: false,
    usesSymbol: false,
    neighbours: false,
    options: {
      red: "Feminine",
      orange: "Somewhat feminine",
      yellow: "Neither feminine nor masculine",
      green: "Somewhat masculine",
      blue: "Masculine",
      purple: "Androgynous",
      intersex: "Intersex",
    },
  },

  // pronouns
  {
    prompt: "My pronouns are...",
    multi: true,
    usesSymbol: true,
    neighbours: false,
    options: {
      she: "She/her",
      they: "They/them",
      he: "He/him",
      other: "Other (ask me)",
      na: "I do not use pronouns",
    },
  },

  // emotional
  {
    prompt: "Emotionally, I am attracted to...",
    multi: true,
    usesSymbol: false,
    neighbours: true,
    options: {
      red: "Feminine traits",
      yellow: "Gender neutral traits",
      blue: "Masculine traits",
      purple: "Androgynous traits",
      rainbow: "All sorts of people!",
      grey: "I don't experience emotional attraction",
    },
  },
  // physical
  {
    prompt: "Physically, I am attracted to...",
    multi: true,
    usesSymbol: false,
    neighbours: true,
    options: {
      red: "Feminine traits",
      yellow: "Gender neutral traits",
      blue: "Masculine traits",
      purple: "Androgynous traits",
      rainbow: "All sorts of people!",
      grey: "I don't experience physical attraction",
    },
  },
  // polyam - can do this as suffix to get the required layout style
  {
    prompt: "I am polyamorous",
    multi: false,
    usesSymbol: true,
    neighbours: false,
    options: {
      grey: "Yes",
      grey_2: "No",
    },
    // suffix: {
    //   // grey: "Yes",
    //   // grey_2: "No",
    // }
  },
];

export { questions };
